<div class="anc-entry-grid" [class.anc-entry-grid--invalid]="invalid()">
    <div class="anc-entry-grid__scroll" [style.min-height]="minHeight()">
        <ng-content></ng-content>
    </div>
    <div class="anc-entry-grid__footer">
        <ng-content select="[ancEntryGridFooter]"></ng-content>
    </div>
</div>
